<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let isBack = false;
</script>

<div on:click={() => dispatch("click")}>
    {#if isBack}
        <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 12L12 18L12 6L2 12Z" fill="#1A1A17"/>
            <path d="M21.5 6.88309L12.9718 12L21.5 17.1169L21.5 6.88309Z" fill="#1A1A17" stroke="#1A1A17"/>
        </svg>


    {:else}
        <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12L12 6L12 18L22 12Z" fill="#1A1A17"/>
            <path d="M2.5 17.1169L11.0282 12L2.5 6.8831L2.5 17.1169Z" fill="#1A1A17" stroke="#1A1A17"/>
        </svg>

    {/if}
</div>
